import dayjs from 'dayjs';

/**
 * Định dạng ngày giao hàng để hiển thị (hiển thị đúng như API trả về, không convert timezone)
 * @param value Chuỗi ngày cần định dạng
 * @returns Chuỗi ngày đã định dạng hoặc chuỗi rỗng nếu không hợp lệ
 */
export const formatDeliveryDateDisplay = (value?: string) => {
    if (!value) return '';
    // Parse date trực tiếp, không convert timezone để hiển thị đúng như API
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : '';
};

/**
 * Định dạng giá trị ngày để gửi lên API (ISO string)
 * @param value Giá trị ngày (dayjs object hoặc string)
 * @param endOfDay Nếu true, set về cuối ngày (23:59:59), nếu false set về đầu ngày (00:00:00)
 * @returns ISO string hoặc undefined nếu không hợp lệ
 */
export const formatDateValue = (value: dayjs.Dayjs | string | undefined, endOfDay = false) => {
    if (!value) return undefined;
    const parsed = dayjs(value);
    if (!parsed.isValid()) return undefined;
    const target = endOfDay ? parsed.endOf('day') : parsed.startOf('day');
    // Trả về định dạng local (không kèm timezone) để tránh lệch giờ
    return target.format('YYYY-MM-DDTHH:mm:ss.SSS');
};

/**
 * Định dạng giá trị ngày chỉ lấy phần date (YYYY-MM-DD) để gửi lên API
 * @param value Giá trị ngày (dayjs object hoặc string)
 * @returns Chuỗi date format YYYY-MM-DD hoặc undefined nếu không hợp lệ
 */
export const formatDateOnly = (value: dayjs.Dayjs | string | undefined) => {
    if (!value) return undefined;
    const parsed = dayjs(value);
    if (!parsed.isValid()) return undefined;
    return parsed.format('YYYY-MM-DD');
};

